export default __webpack_public_path__ + "static/top_business_img-85a010b6de509f1a53ef701ce8d9a0e6.jpg";